module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Frontbmatterbheads"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("Fabric Flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#rose"
    }
  }, [_vm._v("ROSE")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#blossom"
    }
  }, [_vm._v("BLOSSOM")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#dahlia"
    }
  }, [_vm._v("DAHLIA")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("Simple Cupped Flower")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("Lifelike Flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#poppy"
    }
  }, [_vm._v("POPPY")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#peony"
    }
  }, [_vm._v("PEONY")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/1-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "P_CAPbimage"
  }, [_vm._v("Fuchsia Fashionista"), _c('br'), _vm._v("Three-dimensional fabric-effect roses, dahlias and blossoms are used to decorate this gorgeous handbag cake that will make any fashion-conscious woman drool!")]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_vm._v("Whether you choose to add simple cut-out flowers or full-sized lifelike blooms will depend on the look you are after and the time you have available.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-359733d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0